export const MODEL = {
  GT: 'GT',
  iX: 'iX',
  GTL1000: 'GTL-1000',
  GTL1200: 'GTL-1200',
  GM100: 'GM-100',
  GM50: 'GM-50',
  GM120: 'GM-120',
  iM100: 'iM-100',
  iM50: 'iM-50',
  iM120: 'iM-120',
  LN100: 'LN-100',
  LN150: 'LN-150',
  LN160: 'LN-160',
  LN50: 'LN-50',
  LN1000i: 'LN-1000i',
  OS101: 'OS-101',
  OS102: 'OS-102',
  OS103: 'OS-103',
  OS105: 'OS-105',
  OS105F: 'OS-105F',
  OS107: 'OS-107',
  OS107F: 'OS-107F',
  OS101L: 'OS-101L',
  OS103L: 'OS-103L',
  OS105L: 'OS-105L',
  OS200: 'OS-200',
  FX101: 'FX-101',
  FX102: 'FX-102',
  FX103: 'FX-103',
  FX105: 'FX-105',
  FX105F: 'FX-105F',
  FX107: 'FX-107',
  FX107F: 'FX-107F',
  FX101L: 'FX-101L',
  FX102L: 'FX-102L',
  FX105L: 'FX-105L',
  FX200: 'FX-200',
  ESN100: 'ESN-100',
  GTSM1: 'GTS-M1',
  SETM1: 'SET-M1',
};
